import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { storeService } from "../../Services/store.service";
import { globalServices } from "../../Services/global.service";
import ListAdminButtons from "../Common/ListAdminButtons";
import SpinnerLoading from "../Common/SpinnerLoading";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { useTranslation } from "react-i18next";
import DeleteModal from "./DeleteModal";
import Select from "react-select";
import Tooltip from "../Common/Tooltip";
import { roles } from "../../Config/Roles";
import AsyncSelect from "react-select/async";

const Index = () => {
  const {
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    updateLocKey,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);
  const { userId, roleId, tenantId, tenantName } = useContext(AuthContext);
  const { master, admin, support, owner, cashier, accountant } = roles;
  const { t: translator } = useTranslation();

  const [stores, setStores] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [update, setUpdate] = useState(new Date());
  const [selectedItems, setSelectedItems] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });

  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    searchText: "",
    isDeactivated: false,
    sortName: "Description",
    isAsc: true,
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  useEffect(() => {
    updateLocName("stores");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
    updateLocKey(0);
  }, []);

  useEffect(() => {
    if (![master, admin, support, owner].includes(Number(roleId)))
      history.push("/error-page/401");

    storeService
      .get({
        tenantId: Number(search.tenantId),
        searchText: search.searchText,
        isDeactivated: search.isDeactivated,
        sortName: search.sortName,
        isAsc: search.isAsc,
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        setStores(res.data.stores);
        setPagination({ ...pagination, totalCount: res.data.totalCount });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  }, [update, search]);

  const history = useHistory();

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));
        result.unshift({
          id: 0,
          label: translator("SelectTenant-Choose"),
          oib: "",
        });
        return result;
      })
      .catch((err) => err);
  };

  const handleToUpdate = () => {
    if (selectedItems.length !== 1) return false;
    history.push(`/update-store/${selectedItems}`);
  };

  const handleToAdd = () => {
    history.push("/store-add");
  };

  const handleRefresh = () => {
    setIsLoading(true);
    setPagination({ ...pagination, pageIndex: 0 });
    setUpdate(new Date());
  };

  const handleToDetail = () => {
    if (selectedItems.length !== 1) return false;
    history.push(`/stores/${selectedItems}`);
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedItems([...selectedItems, row.storeId]);
    } else {
      setSelectedItems(selectedItems.filter((p) => p !== row.storeId));
    }
  };

  const handleOnSelectAll = (isSelect) => {
    if (isSelect) {
      setSelectedItems(stores.map((x) => x.storeId));
    } else {
      setSelectedItems([]);
    }
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setIsLoading(true);
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (e.target.cellIndex) {
        history.push(`/stores/${row.storeId}`);
      }
    },
  };

  const handleHideDeleteModal = () => setShowDeleteModal(false);

  const confirmDelete = () => {
    let deletePromises = [];

    selectedItems.forEach((x) => {
      deletePromises.push(storeService.deleteStore(x));
    });

    Promise.all(deletePromises)
      .then((data) => {
        setShowDeleteModal(false);
        setModal({
          ...modal,
          title: "Stores-ResultModal-DeleteSuccess-Title",
          text: "Stores-ResultModal-DeleteSuccess-Text",
          show: true,
          btnClass: "btn btn-primary",
        });
        setSelectedItems([]);
        setUpdate(new Date());
      })
      .catch((err) =>
        setModal({
          ...modal,
          title: "Stores-ResultModal-DeleteError-Title",
          text: "Stores-ResultModal-DeleteError-Text",
          show: true,
          btnClass: "btn btn-primary",
        })
      );
  };

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        remote
        keyField="storeId"
        data={data}
        columns={columns}
        rowClasses="boostrap-table-row"
        noDataIndication={translator("No-Data")}
        rowEvents={rowEvents}
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const sorting = (sortName) => {
    setSearch({ ...search, sortName, isAsc: !search.isAsc });
  };

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={selectedItems.find((x) => x === row.storeId)}
            onChange={(e) => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  function actionHeaderFormatter(cell, rows) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={
              stores &&
              stores.length > 0 &&
              !stores
                .map((p) => p.storeId)
                .some((p) => selectedItems.indexOf(p) < 0)
            }
            onChange={(e) => handleOnSelectAll(e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }
  function streetFormatter(cell, row) {
    return `${cell} ${row.streetNumber}${row.streetNumberExtension}`;
  }
  function cityFormatter(cell, row) {
    return `${row.postalNumber}, ${cell}`;
  }

  const columns = [
    {
      dataField: "storeId",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      headerFormatter: actionHeaderFormatter,
      formatter: actionFormatter,
    },
    {
      dataField: "description",
      text: translator("Store-View-TableHeader-Description"),
      headerEvents: { onClick: () => sorting("Description") },
      sort: true,
      sortCaret: (order, column) => {
        if (search.sortName !== "Description")
          return <i className="fa fa-fw fa-sort"></i>;
        if (search.sortName === "Description") {
          return search.isAsc !== true ? (
            <i className="fa fa-fw fa-sort-up"></i>
          ) : (
            <i className="fa fa-fw fa-sort-down"></i>
          );
        }
      },
    },
    {
      dataField: "tag",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "left" };
      },
      text: translator("Store-View-TableHeader-Tag"),
      headerEvents: { onClick: () => sorting("Tag") },
      sort: true,
      sortCaret: (order, column) => {
        if (search.sortName !== "Tag")
          return <i className="fa fa-fw fa-sort"></i>;
        if (search.sortName === "Tag") {
          return search.isAsc !== true ? (
            <i className="fa fa-fw fa-sort-up"></i>
          ) : (
            <i className="fa fa-fw fa-sort-down"></i>
          );
        }
      },
      hidden: Boolean(isMobile),
    },
    {
      dataField: "street",
      text: translator("Store-View-TableHeader-Street"),
      headerEvents: { onClick: () => sorting("Street") },
      formatter: streetFormatter,
      sort: true,
      sortCaret: (order, column) => {
        if (search.sortName !== "Street")
          return <i className="fa fa-fw fa-sort"></i>;
        if (search.sortName === "Street") {
          return search.isAsc !== true ? (
            <i className="fa fa-fw fa-sort-up"></i>
          ) : (
            <i className="fa fa-fw fa-sort-down"></i>
          );
        }
      },
      hidden: Boolean(isMobile),
    },

    {
      dataField: "city",
      headerStyle: (colum, colIndex) => {
        return { width: "220px", textAlign: "left" };
      },
      formatter: cityFormatter,
      text: translator("Store-View-TableHeader-City"),
      headerEvents: { onClick: () => sorting("City") },
      sort: true,
      sortCaret: (order, column) => {
        if (search.sortName !== "City")
          return <i className="fa fa-fw fa-sort"></i>;
        if (search.sortName === "City") {
          return search.isAsc !== true ? (
            <i className="fa fa-fw fa-sort-up"></i>
          ) : (
            <i className="fa fa-fw fa-sort-down"></i>
          );
        }
      },
      hidden: Boolean(isMobile),
    },

  ];

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Store-View-Title-StoreView")}</span>{" "}
          <span className="badge badge-pill badge-primary">
            {" "}
            {!isLoading && pagination.totalCount}
          </span>
          <button
            className={
              "btn btn-primary float-right" + (isMobile ? " btn-sm" : "")
            }
            onClick={handleToAdd}
          >
            <span
              className="icon icon-cancel web-hidden"
              style={{ transform: "rotate(45deg)" }}
            ></span>
            <span className="mob-hidden">
              {translator("Store-View-AddStore")}
            </span>
          </button>
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Store-View-Filters")}
            </legend>
            <form
              className="row"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <label htmlFor="ddlTenants">
                  {translator("Store-View-Filters-Tenants")}
                </label>

                <AsyncSelect
                  name="tenantId"
                  placeholder={translator("Select-Tenant")}
                  onChange={(event) => {
                    setIsLoading(true);
                    setTenantObj({
                      id: event.id,
                      label: event.label,
                      value: event.value,
                    });
                    setSearch({ ...search, tenantId: event.id });
                    setPagination({ ...pagination, pageIndex: 0 });
                  }}
                  defaultOptions={true}
                  loadOptions={promiseOptions}
                  value={tenantObj}
                />
              </div>
              <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <label>{translator("Store-View-Filters-Tag")}</label>{" "}
                <Tooltip text={translator("StoreTooltip-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  value={search.searchText}
                  onChange={(event) => {
                    setIsLoading(true);
                    setSearch({ ...search, searchText: event.target.value });
                    setPagination({ ...pagination, pageIndex: 0 });
                  }}
                />
              </div>
              <div className="form-group col-lg-2 col-md-4 col-xs-12">
                <label className="labelCont mt-5">
                  <input
                    type="checkbox"
                    name="cashDefault"
                    checked={search.isDeactivated}
                    onChange={(event) => {
                      setIsLoading(true);
                      setSearch({
                        ...search,
                        isDeactivated: event.target.checked,
                      });
                      setPagination({ ...pagination, pageIndex: 0 });
                    }}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{translator("POS-ShowDeactivated")}</span>
              </div>
            </form>
          </fieldset>

          <ListAdminButtons
            selectedItemsLength={selectedItems.length}
            handleToDetail={handleToDetail}
            handleToUpdate={
              ![accountant, cashier].includes(Number(roleId))
                ? handleToUpdate
                : null
            }
            handleDelete={
              ![owner, accountant, cashier].includes(Number(roleId))
                ? () => setShowDeleteModal(true)
                : null
            }
            handleRefresh={handleRefresh}
          />

          <DeleteModal
            show={showDeleteModal}
            handleHide={handleHideDeleteModal}
            title={translator("Stores-DeleteModal-Title")}
            text={translator("Stores-DeleteModal-Text")}
            confirmDelete={confirmDelete}
          />

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={stores}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Index;
